import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M.75 21.75h22.5M6 11.25H3a.75.75 0 0 0-.75.75v9.75h4.5V12a.75.75 0 0 0-.75-.75m7.5-9h-3a.75.75 0 0 0-.75.75v18.75h4.5V3a.75.75 0 0 0-.75-.75m7.5 4.5h-3a.75.75 0 0 0-.75.75v14.25h4.5V7.5a.75.75 0 0 0-.75-.75"
    }, null, -1)
  ]));
}
const moneyGraphBarChartIncrease = { render };
export {
  moneyGraphBarChartIncrease as default,
  render
};
//# sourceMappingURL=money-graph-bar-chart-increase.svg.js.map
